/* eslint-disable import/no-anonymous-default-export */
import { LOCALES } from "../locales";

export default {
  [LOCALES.ENGLISH]: {
    hello: "Hello"
  },
};
